// drawLine.js
export function drawLine() {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll(".animated-line path").forEach((path) => {
    const length = path.getTotalLength();

    // Reset
    gsap.set(path, {
      strokeDasharray: length,
      strokeDashoffset: length,
      visibility: "visible"
    });

    // Animate
    gsap.to(path, {
      strokeDashoffset: 0,
      duration: 1.4,
      ease: "power2.out",
      scrollTrigger: {
        trigger: path,
        start: "top 80%",
        once: true
      }
    });
  });
}
